<script setup>
import { computed, inject, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

import MetricCard from './overview/MetricCard.vue';
import OverviewEntityList from './overview/OverviewEntityList.vue';
import { LIVE_METRICS, buildLiveMetric } from './overview/liveMetrics';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useLiveRefresh } from 'dashboard/composables/useLiveRefresh';

const { t } = useI18n();
const openOverviewDetail = inject('openOverviewDetail', null);

const store = useStore();

const uiFlags = useMapGetter('getOverviewUIFlags');
const teamConversationMetric = useMapGetter('getTeamConversationMetric');
const teams = useMapGetter('teams/getTeams');

const fetchData = () => store.dispatch('fetchTeamConversationMetric');

const { startRefetching } = useLiveRefresh(fetchData);

const items = computed(() =>
  teams.value
    .map(team => {
      const metric =
        teamConversationMetric.value.find(
          metrics => metrics.team_id === Number(team.id)
        ) || {};
      return {
        id: team.id,
        name: team.name,
        metrics: Object.keys(LIVE_METRICS).map(key =>
          buildLiveMetric(t, key, metric[key])
        ),
      };
    })
    .sort(
      (a, b) =>
        b.metrics[0].value - a.metrics[0].value || a.name.localeCompare(b.name)
    )
);

const openTeam = item => {
  openOverviewDetail?.({
    title: item.name,
    description: t('OVERVIEW_REPORTS.TEAM_CONVERSATIONS.HEADER'),
    kind: 'conversations',
    source: 'live',
    params: { metric: 'assigned', team_id: item.id },
    tabs: item.metrics.map(metric => ({
      key: metric.key,
      label: metric.label,
      count: metric.value,
    })),
  });
};

onMounted(() => {
  store.dispatch('teams/get');
  fetchData();
  startRefetching();
});
</script>

<template>
  <div class="flex flex-row flex-wrap max-w-full">
    <MetricCard :header="$t('OVERVIEW_REPORTS.TEAM_CONVERSATIONS.HEADER')">
      <OverviewEntityList
        :items="items"
        :is-loading="uiFlags.isFetchingTeamConversationMetric"
        :loading-message="
          $t('OVERVIEW_REPORTS.TEAM_CONVERSATIONS.LOADING_MESSAGE')
        "
        :empty-title="$t('OVERVIEW_REPORTS.TEAM_CONVERSATIONS.NO_TEAMS')"
        :search-placeholder="$t('OVERVIEW_REPORTS.SEARCH_TEAMS')"
        @select="openTeam"
      />
    </MetricCard>
  </div>
</template>
